import type { PWAMetadata } from "../../src/types";

export function generateManifest(metadata: PWAMetadata): string {
  return `${JSON.stringify(
    {
      name: metadata.name ?? "Go Offline App",
      short_name: metadata.shortName ?? metadata.name ?? "Offline App",
      description: metadata.description ?? "Offline-ready app powered by go-offline.",
      start_url: metadata.startUrl ?? "/",
      display: metadata.display ?? "standalone",
      theme_color: metadata.themeColor ?? "#0f172a",
      background_color: metadata.backgroundColor ?? "#ffffff",
      icons:
        metadata.icons ?? [
          {
            src: "/icon-192.png",
            sizes: "192x192",
            type: "image/png"
          },
          {
            src: "/icon-512.png",
            sizes: "512x512",
            type: "image/png"
          }
        ]
    },
    null,
    2
  )}\n`;
}
